import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`${process.env.REACT_APP_API_HOST}/announcement_reject/`, data);
};

const get = async (id) => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/announcement_reject/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`${process.env.REACT_APP_API_HOST}/announcement_reject/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`${process.env.REACT_APP_API_HOST}/announcement_reject/${id}`);
};

const filter = async (query) => {
  return await httpClient.get(`${process.env.REACT_APP_API_HOST}/announcement_reject${query}`);
};

export {
  post,
  get,
  put,
  remove,
  filter
};
